import React, { useState } from "react";
import { IoStatsChart } from "react-icons/io5";

export interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabProps {
  tabs: Tab[];
  loading?: boolean;
  hasData?: boolean;
}

export const ChartTabs: React.FC<TabProps> = ({
  tabs,
  loading = false,
  hasData = true,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (index: number) => {
    setActiveTab(index);
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="vi-glass-card flex flex-col items-center justify-center h-96 w-full mt-2 p-2 mb-10">
          <div className="w-8 h-8 border-4 border-[color:var(--vi-accent)] border-t-transparent rounded-full animate-spin mb-4"></div>
          <div className="text-[color:var(--vi-text)] font-inter">Your graph is loading</div>
        </div>
      );
    }

    if (!hasData) {
      return (
        <div className="vi-glass-card flex flex-col items-center justify-center h-96 w-full mt-2 p-2 mb-10">
          <div className="bg-[color:color-mix(in_srgb,var(--vi-accent)_12%,transparent)] w-12 h-12 flex items-center justify-center mb-2 rounded-full">
            <IoStatsChart className="text-[color:var(--vi-accent)]" />
          </div>
          <div className="text-[color:var(--vi-text)] font-inter">
            Select a stock to uncover its financial story
          </div>
          {/* <div className="text-[#667085] text-sm text-center font-inter mt-2">
            Select one or more stocks and parameters to display
            <br />
            the resulting graph here.
          </div> */}
        </div>
      );
    }

    return (
      <div className="vi-glass-card flex w-full mt-2 p-2 mb-10 ">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={activeTab === index ? "flex w-full" : "hidden"}
          >
            {tab.content}
          </div>
        ))}
      </div>
    );
  };

  // "Equations Used" is a reference tab rather than a graph view, so it
  // sits on its own at the right edge of the row (like the old "Save
  // Graph" button's position) instead of inline with Percentage/
  // Absolute/Days/Multiples on the left.
  const graphTabs = tabs
    .map((tab, index) => ({ tab, index }))
    .filter(({ tab }) => tab.label !== "Equations Used");
  const equationsTab = tabs
    .map((tab, index) => ({ tab, index }))
    .find(({ tab }) => tab.label === "Equations Used");

  const renderTabButton = ({
    tab,
    index,
  }: {
    tab: Tab;
    index: number;
  }) => (
    <button
      key={index}
      onClick={() => handleClick(index)}
      className={`vi-dg-pill px-4 py-2 mr-2 text-sm !font-[500] !font-inter rounded-lg ${
        activeTab === index ? "vi-dg-pill-active" : ""
      }`}
    >
      {tab.label}
    </button>
  );

  return (
    <div className="flex w-full flex-col">
      <div className="flex overflow-x-auto">
        <div className="flex w-full items-center justify-between">
          <div className="flex">{graphTabs.map(renderTabButton)}</div>
          {equationsTab && (
            <div className="flex">
              {renderTabButton(equationsTab)}
            </div>
          )}
        </div>
      </div>
      {renderContent()}
    </div>
  );
};
